import { combineReducers } from 'redux';

import provision2BaseRatesSetup from './provision2BaseRatesSetup/reducer';

export default combineReducers({
  provision2BaseRatesSetup,
});



// WEBPACK FOOTER //
// ./src/pages/provision2baseratessetup/state/reducer.js